import { createBrowserHistory } from 'history';
import React from 'react';
export const appHistory = {
  get history() {
    return getAppHistory();
  }

};
let lastHistory = createBrowserHistory();
export const injectAppHistory = newHistory => {
  lastHistory = newHistory;
};

const getAppHistory = () => {
  return lastHistory;
};

export const useHistory = () => {
  const [history, setHistory] = React.useState(getAppHistory());
  React.useEffect(() => {
    const unlisten = appHistory.history.listen(() => {
      setHistory(getAppHistory());
    });
    return () => {
      unlisten();
    };
  }, []);
  return history;
};